const SATURDAY = 6
const SUNDAY = 0

function isWeekend(date: Date): boolean {
  const day = date.getDay()
  return day === SATURDAY || day === SUNDAY
}

export function addWorkingDays(from: Date, days: number): Date {
  const date = new Date(from.getTime())
  let left = days

  while (left > 0) {
    date.setDate(date.getDate() + 1)
    if (!isWeekend(date)) left -= 1
  }

  return date
}

// Forward to Monday, used for the calendar-day rule.
export function skipWeekend(date: Date): Date {
  const moved = new Date(date.getTime())
  while (isWeekend(moved)) moved.setDate(moved.getDate() + 1)

  return moved
}

export function addCalendarDays(from: Date, days: number): Date {
  const date = new Date(from.getTime())
  date.setDate(date.getDate() + days)

  return skipWeekend(date)
}

export function nextWorkingDay(from: Date = new Date()): Date {
  return addWorkingDays(from, 1)
}

export function toDateInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0")

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
